"use strict";

var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RadioGroupQuestion;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
var _Radio = require("@mui/material/Radio");
var _Radio2 = _interopRequireDefault(_Radio);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _Button = require("@mui/material/Button");
var _Button2 = _interopRequireDefault(_Button);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
var _TextField = require("@mui/material/TextField");
var _TextField2 = _interopRequireDefault(_TextField);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var RadioItem = (0, _styledComponents2.default)(_Button2.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    display: flex;\n    margin-top: 1px;\n    padding: 0;\n    padding-right: 20px;\n    text-transform: none;\n  }\n"])));
var RadioItemNoRipple = _styledComponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  && {\n    display: flex;\n    margin-top: 1px;\n    padding: 0;\n    padding-right: 20px;\n    align-items: center;\n    input {\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n"])));
function RadioGroupQuestion(_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer;
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, question.defaultAnswer || undefined),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  var _ref4 = (0, _react.useState)(question.choices.some(function (c) {
      return c === answer || (c || {}).value === answer;
    }) ? "" : answer),
    _ref5 = _slicedToArray(_ref4, 2),
    otherText = _ref5[0],
    changeOtherText = _ref5[1];
  var choices = question.choices.map(function (c) {
    return typeof c === "string" ? {
      text: c,
      value: c
    } : c;
  });
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer !== undefined,
    error: error
  }, choices.map(function (_ref6) {
    var value = _ref6.value,
      text = _ref6.text;
    return _react2.default.createElement(RadioItem, {
      onClick: function onClick() {
        return changeAnswer(value);
      },
      key: value
    }, _react2.default.createElement(_Radio2.default, {
      tabIndex: -1,
      checked: answer === value,
      id: question.id ? question.id + text : ""
    }), _react2.default.createElement(_QuestionText2.default, null, text));
  }), question.hasOther && _react2.default.createElement(RadioItemNoRipple, {
    tabIndex: -1
  }, _react2.default.createElement(_Radio2.default, {
    checked: answer === otherText,
    onClick: function onClick() {
      return changeAnswer(otherText);
    },
    id: question.id ? question.id : ""
  }), _react2.default.createElement(_TextField2.default // inputProps={{ style: { fontSize: 8 } }}
  , {
    value: otherText,
    onChange: function onChange(e) {
      if (answer === otherText) {
        changeOtherText(e.target.value);
        changeAnswer(e.target.value);
      } else {
        changeOtherText(e.target.value);
      }
    },
    id: question.id ? question.id + "Other" : ""
  })));
}